
import ColorSwatchItem from './color-swatches-item'
export default {
  components: { ColorSwatchItem },
  inject: ['wording', 'product'],
  props: {
    sampleColor: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      product: this.product,
      wording: this.wording,
      hoverredColor: null,
    }
  },
  computed: {
    colors() {
      return this.product.colors
        .filter((color) => color.availability)
        .sort((a, b) => a.internal_type - b.internal_type)
    },
    colorToDisplay() {
      return this.hoverredColor || this.sampleColor
    },
    selectedColorCode() {
      return (
        this.$route.query?.variant?.split('-')[1] ||
        this.product.internal_color_code
      )
    },
    selectedInternalType() {
      return (
        this.$route.query?.variant?.split('-')[0] || this.product.internal_type
      )
    },
  },
  methods: {
    cleanHoverred() {
      this.hoverredColor = null
    },
    hoverColor(color) {
      this.hoverredColor = color?.sample_color || color?.normalized_color
    },
  },
}
